/**
 * Inline's overlapping production verification-key ring.
 *
 * These are public keys, not credentials. Low-level connection callers may supply a different
 * pinned ring for a custom server; the high-level Inline SDK uses this ring by default.
 */
export const INLINE_PROTOCOL_PRODUCTION_PUBLIC_KEYS = [
    {
        modulus: "y4mCEOAFrQU02g6WBGLvsy6hBh9jOfV6Hg6lvKvnRKj2vybdLTISXilcYbN2ItUfXhFf7Tk660OLhD7lBv2Pme9YVmWswHJ9j7PyyIa6klTiBLSADPPCuknvID1X7bX-Ut5IwmJDciSITHy0Qxf5yGnhRWPWOgxWDt4EdwHiOd9uHwCxLn9k8LfIXN2DOT8aPH306IB0IWMsTlnXBZ7om8nZniJG0NWG1u-BJDEk4Hz8eko1cF4wc-naVY4qcDh9zD9iXrbMJ5b8aw2JG11dvJGEBmWqjPcPJy1VqFNAZOxGUf-LXWRTnNuwECRpgvqm5oO_CFfwXUvM5W1Tw7lIVQ",
        exponent: "AQAB",
        fingerprint: "-8339382514522710386",
    },
    {
        modulus: "mHcArJ0brV69p-pgk5aHpEGWMw1sp-fB7CIxqNTQU9_cTBTUzsBykiEEkZfSj1bCYuTkyhPmlsrf4yA9vP8I5rQqf7UGD1Za_W2qbbv3Wv4C3w4yV-bNJUlxG4qokDHszKgDcNumLJq8uIItXnzeg64UzKW2Bm9KikLtJTB-tq18rrNZ43xS5sZK9HHjvO3i--PdpqB0JVSD4VmjIbXHgq7v9czsYbuqlDn4mCj0rCKylQPxCKVrxbtcuP_brwW-foIkjjX8T7Q5Mi_0Zqx-VZZY7AkT8L7LJH5Lgje_IxYQp2zcLjCQf_ZNioCR0xCPMySvJnBTmVwa65wH0alkPQ",
        exponent: "AQAB",
        fingerprint: "-3957383261870667958",
    },
];
